import { render } from "./Alerts.view.vue?vue&type=template&id=847fb922&scoped=true&ts=true"
import script from "./Alerts.view.vue?vue&type=script&lang=ts"
export * from "./Alerts.view.vue?vue&type=script&lang=ts"

import "./Alerts.view.vue?vue&type=style&index=0&id=847fb922&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847fb922"]])

export default __exports__